<div class="summary theme-new-green">
    <div id="page-header" class="banner-area-1 button-end">
        <h1 class="bh-sl-title first">My Events</h1>
        <div>
            <span (click)="createNewEvent()" class="btn btn-primary btn-xs" tooltip="Create new event">Create New
                Event</span>
        </div>
    </div>
    <div class="row">
        <p-table 
            [value]="events" 
            [responsive]="true" 
            [paginator]="true"
            [rows]="10"
            [rowsPerPageOptions]="[5, 10, 25, 50]"
            class=" mt-2">
            <ng-template pTemplate="header">
                <tr>
                    <th scope="col" pSortableColumn="sales_location" >Sales Location <p-sortIcon field="sales_location"></p-sortIcon></th>
                    <th scope="col" pSortableColumn="event_start_datetime">Event Schedule <p-sortIcon field="event_start_datetime"></p-sortIcon></th>
                    <th scope="col" pSortableColumn="is_broadcast">Broadcasted? <p-sortIcon field="is_broadcast"></p-sortIcon></th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-event>
                <tr>
                    <td>{{ event.sales_location }}</td>
                    <td>
                        <ng-container
                            *ngIf="event.event_start_datetime || event.event_end_datetime; else emptySchedule">
                            <span class="icon-calander-green"></span>
                            <ng-container *ngIf="event.event_start_datetime">
                                {{ event.event_start_datetime | momentDate:'mediumDate':event.location_timezoneId }}
                                {{ event.event_start_datetime | momentDate:'shortTime':event.location_timezoneId }}
                            </ng-container>
                            <ng-container *ngIf="event.event_end_datetime && event.event_start_datetime">
                                - {{ event.event_end_datetime | momentDate:'shortTime':event.location_timezoneId }}
                            </ng-container>
                        </ng-container>
                        <ng-template #emptySchedule></ng-template>
                    </td>
                    <td>{{ event.is_broadcast ? 'Yes' : 'No' }}</td>
                    <td>
                        <a [routerLink]="['/event/', event.event_id, 'location']" target="_blank" type="button" pButton
                            icon="pi pi-pencil" class="ui-button-rounded ui-button-text ui-button-success mr-2"></a>
                        <a *ngIf="event.is_broadcast" [routerLink]="['/event-detail/', event.event_id]" target="_blank" type="button" pButton
                            icon="pi pi-eye" class="ui-button-rounded ui-button-text ui-button-success mr-2"></a>
                        <button type="button" pButton icon="pi pi-trash" (click)="confirmDeleteEvent(event)"
                            class="ui-button-rounded ui-button-text ui-button-danger"></button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="3">No events found.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
<ng-template #deleteEventConfirm>
    <div class="modal-body text-center">
        <p>Are you sure to delete the event <strong>{{deleteEvent.sales_location}}</strong>?</p>
        <button type="button" class="btn btn-default" (click)="confirmDelete()">Yes</button>
        <button type="button" class="btn btn-primary" (click)="decline()">No</button>
    </div>
</ng-template>